// extracted by mini-css-extract-plugin
export default {"isFixed":"tnc-module__isFixed__SHktU","storybook":"tnc-module__storybook__XCpIv"};